import { GTMWindow } from '../model';

export const getRelativePath = (windowReference: GTMWindow): string =>
    windowReference.document.location.pathname;
